import React from 'react';
import { Wrench } from 'lucide-react';
import CsvHydrate from './CsvHydrate';
import MassUnsubReview from './MassUnsubReview';
import BulkUpdate from './BulkUpdate';
import MxLookup from './MxLookup';

interface List {
  listid: number;
  name?: string;
  listname?: string;
}

interface Segment {
  segmentid: number;
  segmentname: string;
}

interface Props {
  lists: List[];
  segments: Segment[];
}

export default function Utilities({ lists, segments }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2">
          <Wrench className="h-5 w-5 text-slate-500" />
          Utilities
        </h2>
        <p className="text-sm text-gray-500 dark:text-slate-400 mt-0.5">
          Rare maintenance tools — CSV Hydrate, Mass Unsub Review, Bulk Update, and MX Lookup.
        </p>
      </div>

      <CsvHydrate lists={lists} />
      <MassUnsubReview lists={lists} segments={segments} />
      <BulkUpdate lists={lists} />
      <MxLookup lists={lists} segments={segments} />
    </div>
  );
}
